module.exports = __webpack_public_path__ + "static/img/rankboardClick-H.5b3d290.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/rankboardClick-H.png
// module id = P5LY
// module chunks = 1